"use client"

import { useEffect, useState } from 'react'

interface MapCardProps {
  title: string
  iframeSrc: string
  height?: number
  actions?: React.ReactNode
}

export default function MapCard({ title, iframeSrc, height = 420, actions }: MapCardProps) {
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 500)
    return () => clearTimeout(timer)
  }, [])

  return (
    <div className="bg-white rounded-lg shadow-sm">
      <div className="flex items-center justify-between px-4 py-3 border-b">
        <h3 className="text-sm font-medium text-gray-900">{title}</h3>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
      <div className="relative">
        {isLoading && (
          <div className="absolute inset-0 animate-pulse">
            <div className="h-full w-full bg-gray-200" />
          </div>
        )}
        <iframe
          title={title}
          src={iframeSrc}
          width="100%"
          height={height}
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          className="w-full"
        />
      </div>
    </div>
  )
}